/**
 * Flipnovel 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors, theme as brandTheme } from '@/config/brands'

function hexToRgba(color: string, alpha: number) {
  if (!color.startsWith('#'))
    return color

  const hex = color.slice(1)
  const normalizedHex = hex.length === 3
    ? hex.split('').map(char => char + char).join('')
    : hex

  const red = Number.parseInt(normalizedHex.slice(0, 2), 16)
  const green = Number.parseInt(normalizedHex.slice(2, 4), 16)
  const blue = Number.parseInt(normalizedHex.slice(4, 6), 16)

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

const primaryGradientStart = '#FF8A4C'
const primaryGradientEnd = '#FF5A36'
const primaryGradient = brandTheme.primaryGradient || `linear-gradient(90deg, ${primaryGradientStart} 0%, ${primaryGradientEnd} 100%)`
const paymentStickyBgStart = brandTheme.bgGlobal || '#141821'
const paymentStickyGradient = `linear-gradient(to top, ${paymentStickyBgStart} 0%, ${paymentStickyBgStart} 34%, ${hexToRgba(paymentStickyBgStart, 0.92)} 58%, ${hexToRgba(paymentStickyBgStart, 0.72)} 74%, ${hexToRgba(paymentStickyBgStart, 0.36)} 88%, ${hexToRgba(paymentStickyBgStart, 0)} 100%)`

export const flipnovelPaymentConfig: BrandPaymentConfig = {
  brand: 'flipnovel',

  // 充值页面配置
  pay: {
    theme: {
      isLightPaymentSelector: false,
      paymentStickyGradient,
      colors: {
        tagGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      },
    },
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/flipnovel/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    darkPaymentSelector: true,
    resources: {
      vipBg: '/images/flipnovel/vip_bg.webp',
      memberSubscribeBg: '/images/flipnovel/member_subscribe_bg.webp',
      vipIcon: '/images/flipnovel/vip_icon2.png',
      vipDiscountIcon: '/images/flipnovel/vip_discount.png',
      discountBg: '/images/flipnovel/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: primaryGradient,
      purpleTextGradient: 'linear-gradient(180deg, #FFD4C5 0%, #FFB89F 70%, #FFEDE6 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
      subscribeCardBg: 'linear-gradient(90deg, #443431, #261b1a)',
      cycleTextGradient: 'linear-gradient(180deg, #98462D 0%, #2B2426 100%)',
      badgeGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    darkPaymentSelector: true,
    themeDefaults: {
      background: '#292929',
      size: '38',
    },
    colors: {
      coinsGradient: `linear-gradient(180deg, ${brandColors!.primary}, ${brandColors!.bg.global})`,
      coinsPopupText1: brandColors!.text.inverse,
      coinsPopupText2: primaryGradientStart,
      coinsPopupText3: brandColors!.text.secondary,
      coinsPopupText4: brandColors!.text.inverse,
      vipBg: brandColors!.bg.card,
      subscribeActiveBg: brandColors!.bg.card,
      purpleTextGradient: 'linear-gradient(180deg, #FFD4C5 0%, #FFB89F 70%, #FFEDE6 100%)',
      pinkGradient: primaryGradient,
      subscribeCardBg: 'linear-gradient(90deg, #443431, #261b1a)',
      purchaseActiveBg: '#222936',
      memberSubscribeBg: '/images/flipnovel/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
